import { render, staticRenderFns } from "./ClientFlowContactPopUp.vue?vue&type=template&id=a5531cac&scoped=true&"
import script from "./ClientFlowContactPopUp.vue?vue&type=script&lang=js&"
export * from "./ClientFlowContactPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5531cac",
  null
  
)

export default component.exports